import { AppStateContext } from 'lib/contexts/AppState';
import { useContext } from 'react';

export const useAppState = () => {
  return useContext(AppStateContext);
};
